import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import AppRoutes from "./AppRoutes";
import Navbar from "./views/shared/Navbar";
import Sidebar from "./views/shared/Sidebar";

const App = () => {
  const { pathname } = useLocation();
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);

  const onRouteChanged = () => {
    console.log("ROUTE CHANGED");
    const body = document.querySelector("body");
    if (pathname === "/layout/RtlLayout") {
      body.classList.add("rtl");
    } else {
      body.classList.remove("rtl");
    }
    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = [
      "/login",
      "/forgot_password",
      "/forgot_password/otp",
      "/change_password",
      "/terms&conditions",
      "/privacypolicy",
      "/liability-waiver",
      "/support",
      "/404",
      "/500",
    ];
    const isFullPage = fullPageLayoutRoutes.includes(pathname);
    setIsFullPageLayout(isFullPage);
    if (!isFullPage) {
      if (
        pathname.startsWith("/reset_password") ||
        pathname.startsWith("/signup") ||
        pathname.startsWith("/verified")
      ) {
        setIsFullPageLayout(true);
      }
    }
  };

  useEffect(() => {
    onRouteChanged();
  }, [pathname]);

  let navbarComponent = !isFullPageLayout ? <Navbar /> : "";
  let sidebarComponent = !isFullPageLayout ? <Sidebar /> : "";

  // Disable right-click
  // document.addEventListener('contextmenu', (e) => e.preventDefault());

  // function ctrlShiftKey(e, keyCode) {
  //   return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
  // }

  // document.onkeydown = (e) => {
  //   // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
  //   if (
  //     e.keyCode === 123 ||
  //     ctrlShiftKey(e, 'I') ||
  //     ctrlShiftKey(e, 'J') ||
  //     ctrlShiftKey(e, 'C') ||
  //     (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
  //   )
  //     return false;
  // };

  return (
    <div className="container-scroller">
      {navbarComponent}
      <div
        className={`container-fluid page-body-wrapper ${
          pathname === "/forgot_password" ||
          pathname === "/forgot_password/otp" ||
          pathname.startsWith("/reset_password") ||
          pathname === "/login" ||
          pathname === "/change_password" ||
          pathname === "/terms&conditions" ||
          pathname === "/privacypolicy" ||
          pathname === "/liability-waiver" ||
          pathname === "/support" ||
          pathname.startsWith("/verified") ||
          pathname === "/404" ||
          pathname === "/500"
            ? "full-page-wrapper p-0"
            : ""
        }`}
      >
        {sidebarComponent}
        <div className="main-panel">
          <div className="content-wrapper">
            <AppRoutes />
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
